/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { Parameter } from '../../../models/common/Parameter';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { IOasParameterParent } from '../../../../openapi/models/IOasParameterParent';
import { OasParameter } from '../../../../openapi/models/OasParameter';
import { Node } from '../../../models/Node';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasBodyParameterUniquenessValidationRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        let param : OasParameter = <OasParameter>node;
        let params : Array<OasParameter> = (<IOasParameterParent><any>(node.parent())).getParameters();
        if(this.equals(param.in, "body")) {
            let count : number = this.countBodyParams(params);
            this.reportIf(count > 1, node, Constants.PROP_IN, this.map.apply(this, ));
        }
    }

    /**
     * Counts the # of body style params.
     * @param {OasParameter[]} params
     * @return {number}
     * @private
     */
    /*private*/ countBodyParams(params : Array<OasParameter>) : number {
        let count : number = 0;
        for(let index216=0; index216 < params.length; index216++) {
            let parameter = params[index216];
            {
                if(this.equals(parameter.in, "body")) {
                    count++;
                }
            }
        }
        return count;
    }
}
OasBodyParameterUniquenessValidationRule["__class"] = "io.apicurio.datamodels.core.validation.rules.other.OasBodyParameterUniquenessValidationRule";
OasBodyParameterUniquenessValidationRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




